export namespace Sounds {
  export const Channel = {
    SFX: 'sfx',
    Music: 'music'
  } as const;

  // Snd + Character + Partial + Number
  export const Partial = {} as const;

  export const Character = {} as const;
  export type CharacterKeys = keyof typeof Character;
  export type CharacterValues = typeof Character[CharacterKeys];

  export const Track = {
    /* START OF GENERATED TRACK CODE */

    // ### SndItemClick
    SndItemClick: 'SndItemClick',


    // ### Cheer
    Cheer: 'Cheer',

    // ### BonusPoints1
    BonusPoints1: 'BonusPoints1',
    // ### BonusPoints2
    BonusPoints2: 'BonusPoints2',

    // ### Pickup1
    Pickup1: 'Pickup1',
    // ### Pickup2
    Pickup2: 'Pickup2',
    // ### Pickup3
    Pickup3: 'Pickup3',
    // ### Pickup4
    Pickup4: 'Pickup4',

    // ### Taz_Laugh_2
    TazLaugh_2: 'Taz_Laugh_2',
    // ### Taz_Laugh_3
    TazLaugh_3: 'Taz_Laugh_3',
    // ### Taz_Laugh_4
    TazLaugh_4: 'Taz_Laugh_4',
    // ### Taz_Laugh_5
    TazLaugh_5: 'Taz_Laugh_5',

    // ### SndGameMusicLoop
    SndGameMusicLoop: 'SndGameMusicLoop',

    // ### SndFailTrombone
    SndFailTrombone: 'SndFailTrombone',
    // ### SndPartyHorn2
    SndPartyHorn2: 'SndPartyHorn2',
    // ### box-smash-1
    BoxSmash_1: 'box-smash-1',
    // ### box-smash-2
    BoxSmash_2: 'box-smash-2',
    // ### box-smash-3
    BoxSmash_3: 'box-smash-3',
    // ### boxHit1
    BoxHit1: 'boxHit1',
    // ### boxHit2
    BoxHit2: 'boxHit2',
    // ### boxHit3
    BoxHit3: 'boxHit3',
    // ### boxHit4
    BoxHit4: 'boxHit4',
    // ### boxHit5
    BoxHit5: 'boxHit5',
    // ### boxHit6
    BoxHit6: 'boxHit6',
    // ### boxHit7
    BoxHit7: 'boxHit7',
    // ### boxHit8
    BoxHit8: 'boxHit8',
    // ### boxHit9
    BoxHit9: 'boxHit9',
    // ### bullet
    Bullet: 'bullet',
    // ### canary
    Canary: 'canary',
    // ### doing_punch
    DoingPunch: 'doing_punch',
    // ### elastic_spring
    ElasticSpring: 'elastic_spring',
    // ### marvinMartian
    MarvinMartian: 'marvinMartian',
    // ### pinball-bumper
    PinballBumper: 'pinball-bumper',
    // ### swish1
    Swish1: 'swish1',
    // ### swish2
    Swish2: 'swish2',
    // ### swish3
    Swish3: 'swish3',
    // ### swish4
    Swish4: 'swish4',

    // ### fireworks
    Fireworks: 'fireworks',

    // ### star
    Star: 'star',

    // ### PorkyPig
    PorkyPig: 'PorkyPig',
    

    // ### CountryMusicLoop
    CountryMusicLoop: 'CountryMusicLoop',
    // ### DesertMusicLoop
    DesertMusicLoop: 'DesertMusicLoop',
    // ### IceMusicLoop
    IceMusicLoop: 'IceMusicLoop',
    // ### SpaceMusicLoop
    SpaceMusicLoop: 'SpaceMusicLoop',

   
    TazAngryGrowl: 'Taz_AngryGrowl',
    // ### Taz_AngryYell
    TazAngryYell: 'Taz_AngryYell',
    // ### Taz_HappyHmms
    TazHappyHmms: 'Taz_HappyHmms',
    // ### Taz_HappyWoah
    TazHappyWoah: 'Taz_HappyWoah',
    // ### Taz_HappyYellandSlurp
    TazHappyYellandSlurp: 'Taz_HappyYellandSlurp',
    // ### Taz_ShortUnhappyGrunt
    TazShortUnhappyGrunt: 'Taz_ShortUnhappyGrunt',
    // ### Taz_UnhappyNoises
    TazUnhappyNoises: 'Taz_UnhappyNoises',
    // ### Taz_UnhappyYell
    TazUnhappyYell: 'Taz_UnhappyYell',
    // ### Taz_YeahYeahYeah
    TazYeahYeahYeah: 'Taz_YeahYeahYeah',
    // ### Tweety_Hey!
  

    // ### bugsbunny_carousel
    BugsbunnyCarousel: 'bugsbunny_carousel',
    // ### bugsbunny_powerup
    BugsbunnyPowerup: 'bugsbunny_powerup',
    
    RoadrunnerCarousel: 'roadrunner_carousel',
    // ### taz-whirl-loop
    TazWhirlLoop: 'taz-whirl-loop',

    // ### marvinmartian_carousel
    MarvinmartianCarousel: 'marvinmartian_carousel',
    // ### marvinmartian_powerup
    MarvinmartianPowerup: 'marvinmartian_powerup',
    // ### porkypig_carousel
    PorkypigCarousel: 'porkypig_carousel',
    // ### porkypig_powerup
    PorkypigPowerup: 'porkypig_powerup',
    // ### tweetybird_carousel
    TweetybirdCarousel: 'tweetybird_carousel',
    // ### tweetybird_powerup
    TweetybirdPowerup: 'tweetybird_powerup',
    // ### yosemitesam_carousel
    YosemitesamCarousel: 'yosemitesam_carousel',

    // ### yosemitesam_powerup
    YosemitesamPowerup: 'yosemitesam_powerup',

    // ### roadrunner_powerup
    RoadrunnerPowerup: 'roadrunner_powerup',


    /* END OF GENERATED TRACK CODE */
  } as const;

  export const Sound = {
    MissionComplete: Track.SndItemClick,
    IntroSwoosh: Track.Swish1,
    EndCheer: Track.Cheer
  } as const;
}
